<!-- <h4 class="h4">(Courier Charges)</h4> -->
<div class="main-content pt-4 mt-0">
  <div class="container-fluid">
    <div class="row justify-content-center"></div>
    <div class="row">
      <div class="col-md-8">
        <div class="card-tools pb-5 pt-2"></div>
        <div class="card">
          <div class="card-header card-header-icon">
            <div class="card-icon">
              <i class="material-icons">receipt</i>
            </div>
            <h4 class="card-title">{{ id ? "Update" : "New" }} Document</h4>
          </div>
          <div class="card-body">
            <form [formGroup]="form" (ngSubmit)="onSubmit()">
              <div class="row">
                <div class="col-md-6">
                  <div class="form-group">
                    <label class="bmd-label-floating" for="name">Name</label>
                    <input
                      type="text"
                      class="form-control"
                      id="name"
                      formControlName="name"
                    />
                    <div
                      class="invalid-feedback"
                      *ngIf="isFieldInvalid('name')"
                    >
                      Name is required
                    </div>
                  </div>
                </div>
                <div class="col-md-3">
                  <div class="form-group">
                    <!-- <label class="bmd-label-floating" for="img"
                      >Select image</label
                    > -->
                    <a
                      (click)="selectFile()"
                      [class.disabled]="upload"
                      [style.pointer-events]="upload ? 'none' : 'auto'"
                      [style.opacity]="upload ? '0.5' : '1'"
                      style="
                        cursor: pointer;
                        text-decoration: underline;
                        color: #007bff;
                      "
                    >
                      Select document
                      <input
                        #fileInput
                        type="file"
                        (change)="captureFile($event)"
                        style="display: none"
                        accept=".pdf,.doc,.docx,.xls,.xlsx,.ppt,.pptx,.txt"
                      />
                    </a>
                    <span *ngIf="upload"> (Uploaded) </span>
                    <button
                      *ngIf="upload"
                      type="button"
                      class="btn btn-dark btn-sm btn-update"
                      (click)="removeFile('doc')"
                    >
                      X
                    </button>
                  </div>
                </div>
              </div>

              <div class="row text-center">
                <div class="col-md-12">
                  <button
                    type="submit"
                    class="btn btn-dark pull-right btn-create"
                    [disabled]="form.invalid"
                  >
                    {{ id ? "Update" : "Load" }}
                  </button>
                </div>
              </div>
              <div class="clearfix"></div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
